exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".label-email {\n  color: white !important;\n  font-size: 0.75em !important;\n  margin-bottom: 0em;\n  font-family: \"29LTBukra\";\n}\n\n.label-generic {\n  color: #A4DBE8 !important;\n  font-size: 1.5em !important;\n  font-weight: bold;\n  padding: 1em 0;\n}", ""]);

